import { __assign } from "tslib";
import { LocalModuleExecutionContextProvider, useSharedExecutionContextNoThrow, } from '@1js/ai-hub-shared-execution-context';
import { useAiHubModuleLogger, useModuleRenderTelemetryLogger, } from '@office-start/ai-hub-telemetry-service';
import ErrorBoundary from '@office-start/error-boundary';
import React, { useCallback } from 'react';
import { v4 as uuid } from 'uuid';
import { AiHubErrorPage } from './AiHubErrorPage';
var AiHubPageErrorBoundary = function (_a) {
    var _b, _c, _d;
    var LazyComponent = _a.LazyComponent, errorEventName = _a.errorEventName, name = _a.name, onError = _a.onError, fallbackRender = _a.fallbackRender;
    var MemoizedFallbackRender = useCallback(function (props) {
        var FallbackComponent = fallbackRender !== null && fallbackRender !== void 0 ? fallbackRender : AiHubErrorPage;
        return React.createElement(FallbackComponent, __assign({}, props, { moduleName: name }));
    }, [fallbackRender, name]);
    var moduleSessionId = React.useMemo(function () { return uuid(); }, []);
    var startTime = React.useMemo(function () { return performance.now(); }, []);
    var getStartTime = React.useCallback(function () { return startTime; }, [startTime]);
    var sharedExecutionContext = useSharedExecutionContextNoThrow();
    var logger = useAiHubModuleLogger(sharedExecutionContext, name, moduleSessionId, getStartTime);
    var _e = useModuleRenderTelemetryLogger(moduleSessionId, name, (_b = sharedExecutionContext === null || sharedExecutionContext === void 0 ? void 0 : sharedExecutionContext.hostContext.baseModuleConfig) === null || _b === void 0 ? void 0 : _b.hostCallbacks, logger), onCaughtError = _e.onCaughtError, onModuleRenderCallback = _e.onModuleRenderCallback;
    var handleModuleError = useCallback(function (error, info) {
        var _a;
        onError === null || onError === void 0 ? void 0 : onError(error, info);
        onCaughtError(error);
        (_a = sharedExecutionContext === null || sharedExecutionContext === void 0 ? void 0 : sharedExecutionContext.hostContext.baseModuleConfig) === null || _a === void 0 ? void 0 : _a.hostCallbacks.reportCriticalFailure(error);
    }, [
        onCaughtError,
        onError,
        (_c = sharedExecutionContext === null || sharedExecutionContext === void 0 ? void 0 : sharedExecutionContext.hostContext.baseModuleConfig) === null || _c === void 0 ? void 0 : _c.hostCallbacks,
    ]);
    var localModuleExecutionContext = React.useMemo(function () {
        return ({
            moduleSessionId: moduleSessionId,
            name: name,
            startTime: performance.now(),
            hostCallbacks: {
                reportCriticalFailure: handleModuleError,
                onModuleRenderCallback: onModuleRenderCallback,
            },
            aiHubModuleLogger: logger,
        });
    }, [
        moduleSessionId,
        name,
        handleModuleError,
        onModuleRenderCallback,
        logger,
    ]);
    return (React.createElement("div", { "data-ai-hub-module-session-id": moduleSessionId, "data-ai-hub-module-name": name, style: { height: '100%' } },
        React.createElement(ErrorBoundary, { fallbackRender: function (props) { return (React.createElement(MemoizedFallbackRender, __assign({}, props, { moduleName: name }))); }, errorEventName: "ErrorBoundaryPage_".concat((_d = errorEventName !== null && errorEventName !== void 0 ? errorEventName : name) !== null && _d !== void 0 ? _d : 'Unknown'), onError: handleModuleError },
            React.createElement(LocalModuleExecutionContextProvider, { localModuleExecutionContext: localModuleExecutionContext },
                React.createElement(React.Suspense, { fallback: null },
                    React.createElement(LazyComponent, null))))));
};
AiHubPageErrorBoundary.displayName = 'AiHubPageErrorBoundary';
export var AiHubPageUnstyled = function (_a) {
    var LazyComponent = _a.LazyComponent, name = _a.name, useLogPageViewHook = _a.useLogPageViewHook;
    useLogPageViewHook({ pageName: name });
    return (React.createElement(AiHubPageErrorBoundary, { fallbackRender: AiHubErrorPage, name: name, LazyComponent: LazyComponent }));
};
AiHubPageUnstyled.displayName = 'AiHubPageUnstyled';
//# sourceMappingURL=AIHubPage.js.map